import { z } from 'zod';
import { AVATAR_ACCESSORIES, AVATAR_HAIR_COLORS, AVATAR_HAIR_STYLES, AVATAR_OUTFIT_COLORS, AVATAR_SKIN_TONES, } from '../types/avatar.js';
export const avatarConfigSchema = z.object({
    skin: z.enum(AVATAR_SKIN_TONES),
    hair: z.enum(AVATAR_HAIR_STYLES),
    hairColor: z.enum(AVATAR_HAIR_COLORS),
    shirtColor: z.enum(AVATAR_OUTFIT_COLORS),
    pantsColor: z.enum(AVATAR_OUTFIT_COLORS),
    accessory: z.enum(AVATAR_ACCESSORIES),
});
//# sourceMappingURL=avatarSchema.js.map